import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export function usePublicApps() {
  const [apps, setApps] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    api
      .get("/public/apps")
      .then(({ data }) => setApps(data))
      .catch(() => {
        setError(true);
        setApps([]);
      });
  }, []);
  return { apps, error };
}
